import { LeaseAccountPaymentStatus, LeaseInterface, SpaceFeature } from "@swivl-mono/types";
import { useMemo } from "react";
import Pill, { PillSize, PillStyle, PillType } from "../Pill/Pill";
import "./DataCard.Lease.scss";

interface LeaseCardProps {
  lease: LeaseInterface;
}

interface PillsProps {
  names: string[];
}

const Pills: React.FC<PillsProps> = ({ names }) => {
  return names?.map((name) => {
    return <Pill type={PillType.DEFAULT} size={PillSize.SMALL} style={PillStyle.LIGHT} text={name}></Pill>;
  });
};

export function DataCardLease(props: LeaseCardProps) {
  const { lease } = props;

  const data = useMemo(() => {
    const unitNumber = lease?.unit?.number;
    const unitFeatures = lease?.unit?.features?.map((feature: SpaceFeature) => feature.toString()) || [];
    const leaseBalance = lease?.balance;
    const leaseAccessCode = lease?.accessCode || "";
    const leasePaymentStatus = lease?.paymentStatus || "";

    return {
      unitNumber,
      unitFeatures,
      leaseBalance,
      leaseAccessCode,
      leasePaymentStatus,
    };
  }, [lease]);

  return (
    <div className="DataCardLease">
      <div className="flex items-center justify-between">
        {data?.unitNumber && <span className="font-semibold">{`Unit ${data?.unitNumber}`}</span>}
        {data?.leasePaymentStatus === LeaseAccountPaymentStatus.PAST_DUE && (
          <span className="text-red-500 capitalize font-semibold">{data?.leasePaymentStatus}</span>
        )}
      </div>

      <div className="CardHeaderBody">
        <div className="CardHeaderBodyColumn">
          <div className="CardHeaderBodyItem flex flex-wrap gap-1">
            <Pills names={data?.unitFeatures} />
          </div>
        </div>
      </div>
      <div className="CardBody">
        <div className="CardBodyColumn">
          <span>Access Code:</span>
          {data?.leaseAccessCode && <span className="font-semibold"> #{data.leaseAccessCode}</span>}
        </div>
        <div className="CardBodyColumn">
          <span>
            Account Balance:
          </span>
          {data?.leaseBalance && <span className="font-semibold"> ${data?.leaseBalance}</span>}
        </div>
      </div>
    </div>
  );
}
